import { render, staticRenderFns } from "./AdvCart.vue?vue&type=template&id=67117814&"
import script from "./AdvCart.vue?vue&type=script&lang=js&"
export * from "./AdvCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports